import { SHOW_SMALL_BOX, HIDE_SMALL_BOX } from '../actions/types'

export default function(state = { visible: false, mapping_id: null }, action = {}) {
  switch(action.type) {
    case SHOW_SMALL_BOX:
    case HIDE_SMALL_BOX:
      return {visible: action.visible, mapping_id: action.mapping_id};
     default:
      return state;
  }
}